import { useAuth } from '@/contexts/AuthContext';
import { Navigate } from 'react-router-dom';
import { usePushNotifications } from '@/hooks/usePushNotifications';

export function ProtectedCustomerRoute({ children }) {
  const { customer, loading } = useAuth();
  usePushNotifications(!!customer);
  if (loading) return <div className="min-h-screen flex items-center justify-center text-muted-ink">Loading…</div>;
  if (!customer) return <Navigate to="/cxlogin" replace />;
  return children;
}
